import { compact } from 'lodash';

import { InsuranceServiceIcon } from '../components/icon/insurance_service_icon/InsuranceServiceIcon';
import { GarageServiceIcon } from '../components/icon/garage_service_icon/GarageServiceIcon';
import { DwepServiceIcon } from '../components/icon/dwep_service_icon/DwepServiceIcon';
import { RefiServiceIcon } from '../components/icon/refi_service_icon/RefiServiceIcon';
import InsuranceServiceImg from '../components/service_split/asset/service_insurance.png';
import RefiServiceImg from '../components/service_split/asset/service_refi.png';
import GarageServiceImg from '../components/service_split/asset/service_garage.png';
import DwepServiceImg from '../components/service_split/asset/service_dwep.png';
import { ENABLE_REFI } from '../utils/constants';

import type { SelectedServiceType } from './app_data';
export interface ServiceSplitOptionsType {
  title: string;
  icon: React.ReactNode;
  value: string;
  isSelected: (selectedService?: SelectedServiceType) => boolean | undefined;
  trackLabel?: string;
  image: React.ReactNode;
}

export const SERVICES_SPLIT_OPTIONS: ServiceSplitOptionsType[] = compact([
  {
    title: 'Insurance Shopping',
    icon: <InsuranceServiceIcon />,
    value: 'insurance',
    isSelected: (selectedService) => !!selectedService?.insurance,
    trackLabel: 'insurance',
    // eslint-disable-next-line @next/next/no-img-element
    image: <img src={InsuranceServiceImg} alt="" />,
  },
  ENABLE_REFI && {
    title: 'Car Loan Refinancing',
    icon: <RefiServiceIcon />,
    value: 'refi',
    isSelected: (selectedService) => !!selectedService?.refi,
    trackLabel: 'refi',
    // eslint-disable-next-line @next/next/no-img-element
    image: <img src={RefiServiceImg} alt="" />,
  },
  {
    title: 'Car Maintenance Reminders',
    icon: <GarageServiceIcon />,
    value: 'garage',
    isSelected: (selectedService) => !!selectedService?.garage,
    trackLabel: 'garage',
    // eslint-disable-next-line @next/next/no-img-element
    image: <img src={GarageServiceImg} alt="" />,
  },
  {
    title: 'Drive Well, Save More',
    icon: <DwepServiceIcon />,
    value: 'dwep',
    isSelected: (selectedService) => !!selectedService?.dwep,
    trackLabel: 'dwep',
    // eslint-disable-next-line @next/next/no-img-element
    image: <img src={DwepServiceImg} alt="" />,
  },
]);
